module.exports = __webpack_public_path__ + "img/he5.a7cf4bd6.png";